import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import Loading from "../../components/loading";
import './style.css';

export default function CertificadoEvento() {
    const [loading, setLoadingStatus] = useState(true);
    const [result, setResult] = useState("");
    let {token} = useParams()

    useEffect(() => {
        setLoadingStatus(true)

        const exec = async () => {

            fetch(`${process.env.REACT_APP_URL_API}certificado-evento/${token}`).then((response) => {
                return response.json();
            }).then((res)    => {
                setResult(res.data.data);
                setLoadingStatus(false)
            }).catch((exp) => {
                console.error('Erro:', exp);
                // setError(exp)
            })
        }
        exec().then();
    }, []);

    return (
        <div>
            {loading ? (Loading()) : (
                <iframe src={"data:application/pdf;base64," + result}></iframe>
            )
            }
        </div>
    )
}
